// First-class metadata for TL game posts.
// Engine & development status are NOT tags — they are dedicated metadata
// fields with indexed filters and dedicated badges.

export const ENGINES = {
  rpgm:     { value: "rpgm",     label: "RPGM",          chip: "bg-sky-600/25 text-sky-200 border border-sky-500/50" },
  unity:    { value: "unity",    label: "Unity",         chip: "bg-orange-600/25 text-orange-200 border border-orange-500/50" },
  wolf_rpg: { value: "wolf_rpg", label: "Wolf RPG",      chip: "bg-emerald-700/30 text-emerald-200 border border-emerald-500/50" },
  unreal:   { value: "unreal",   label: "Unreal Engine", chip: "bg-blue-900/40 text-blue-200 border border-blue-600/60" },
  renpy:    { value: "renpy",    label: "Ren'Py",        chip: "bg-purple-700/30 text-purple-200 border border-purple-500/50" },
  other:    { value: "other",    label: "Other",         chip: "bg-zinc-700/40 text-zinc-300 border border-zinc-500/50" },
};

export const DEV_STATUSES = {
  completed: { value: "completed", label: "Completed", chip: "bg-emerald-600/25 text-emerald-200 border border-emerald-500/50" },
  ongoing:   { value: "ongoing",   label: "Ongoing",   chip: "bg-blue-600/25 text-blue-200 border border-blue-500/50" },
  abandoned: { value: "abandoned", label: "Abandoned", chip: "bg-rose-700/30 text-rose-200 border border-rose-500/60" },
  hiatus:    { value: "hiatus",    label: "Hiatus",    chip: "bg-amber-600/25 text-amber-200 border border-amber-500/50" },
};

export const ENGINE_OPTIONS = Object.values(ENGINES);
export const DEV_STATUS_OPTIONS = Object.values(DEV_STATUSES);

// Safe lookups with backward-compatible defaults.
export const getEngine = (v) => ENGINES[v] || ENGINES.other;
export const getDevStatus = (v) => DEV_STATUSES[v] || DEV_STATUSES.completed;
